/*
 * @Author: LiuXin
 * @Date: 2021-09-27 14:31:42
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-10-29 15:34:33
 */
export class LoadMore {
  constructor(options) {
    this.observer = null;
    this.rootNode = options.root; // 父级容器
    this.obsNode = options.obs; // 守卫节点
    this.loadMoreFn = options.loadMoreFn; // 加载回调
    this.init(); // 初始化
    return this;
  }
  // 交叉触发回调
  callback = entries => {
    // 防止插入瞬间再次触发离开交叉事件
    if (entries[0].intersectionRatio === 0) return;
    this.loadMoreFn();
  };
  // 关闭交叉监听
  cancelObserve() {
    this.observer.unobserve(this.obsNode);
  }
  // 设置首位节点交叉监听
  handleObserve() {
    this.observer.observe(this.obsNode);
  }
  // 初始化
  init() {
    if (this.obsNode && this.rootNode) {
      // 创建 IntersectionObserver 实例子
      this.observer = new IntersectionObserver(this.callback, {
        root: this.rootNode || null, // 交叉窗口、根元素
        rootMargin: '0px', // 交叉窗口边界扩展或者伸缩
        threshold: [0.1], // 交叉占比（0～1），达到该比例才触发回调
      });
      this.handleObserve();
    }
  }
}
